<template>
  <div class="settings-colors">
    <GwMenu
      ref="gwmenu"
      placement="bottom"
      :useVirtualElement="true"
    >
      <template #opener>
        <div
          v-for="(clr, idx) in colors"
          :key="clr.name + idx"
          class="settings-colors_color"
        >
          <div
            :data-tst="`color_${clr.name}`"
            class="color_inner"
            @click="e => selectColor(clr, e)"
          >
            <div
              v-if="clr.hex_to"
              class="color_dot color_gradient"
              :style="`--clr-dot:linear-gradient(90deg, ${getGradient(clr)})`"
            ></div>
            <div
              v-else
              class="color_dot"
              :style="`--clr-dot:${clr.hex}`"
            ></div>
            <div
              :id="`color_${clr.name}`"
              class="color_name d-flex w-100"
            >
              <span class="capitalize">
                {{ $t(`settings.colors.${clr.name}`) }}
              </span>

              <div
                v-if="clr.name === 'R_default'"
                class="ml-2 mdi mdi-help-circle-outline csst clr-grey text-small"
                @mouseenter="fl_positionTooltip"
                @click.stop
              >
                <div
                  class="csst_content text-medium clr-white"
                  style="position: fixed"
                >
                  <div class="capitalize">
                    <span class="weight_700">{{ $t(`browse.bet_small`) }}</span> -
                    {{ $t(`browse.bet_small_help`) }}
                  </div>
                  <div class="capitalize">
                    <span class="weight_700">{{ $t(`browse.bet_medium`) }}</span> -
                    {{ $t(`browse.bet_medium_help`) }}
                  </div>
                  <div class="capitalize">
                    <span class="weight_700">{{ $t(`browse.bet_large`) }}</span> -
                    {{ $t(`browse.bet_large_help`) }}
                  </div>
                  <div class="capitalize">
                    <span class="weight_700">{{ $t(`browse.bet_overbet`) }}</span> -
                    {{ $t(`browse.bet_overbet_help`) }}
                  </div>
                </div>
              </div>

              <div
                v-if="clr.name === 'eveqeqrbl'"
                class="ml-2 mdi mdi-help-circle-outline text-small csst clr-grey"
                @mouseenter="fl_positionTooltip"
              >
                <div
                  class="csst_content clr-white text-medium"
                  style="position: fixed"
                  v-html="$t(`settings.colors.eveqeqrbl_tooltip`)"
                ></div>
              </div>

              <!-- 'range', -->
              <div
                v-for="item in [
                  'range_text',
                  'range_active',
                  'range_empty',
                  'combo_text',
                  'combo_range_active',
                  'combo_range_empty',
                ].filter(n => n === clr.name)"
                :key="item"
                class="ml-2 mdi mdi-help-circle-outline text-small csst clr-grey"
                @mouseenter="fl_positionTooltip"
              >
                <div
                  class="csst_content clr-white text-medium"
                  style="position: fixed"
                  v-html="$t(`tooltips.${item}`)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #default="{ methods }">
        <div
          class="gw_menu"
          style="padding: 0 0.75rem 0.75rem 0.75rem"
        >
          <div class="d-flex pt-2">
            <span
              v-if="selectedColor.name"
              class="capitalize weight_700 text-normal"
            >
              {{ $t(`settings.colors.${selectedColor.name}`) }}
            </span>

            <div
              v-if="selectedColor.name === 'eveqeqrbl'"
              class="ml-2 mdi mdi-help-circle-outline csst"
              @click.stop
            >
              <div
                class="csst_content"
                style="position: fixed"
                v-html="$t(`settings.colors.eveqeqrbl_tooltip`)"
              ></div>
            </div>

            <i
              class="icon_btn mdi-close mdi ml-auto mb-auto pa-1"
              @click="methods.toggleOpen(false)"
            ></i>
          </div>
          <div
            v-if="selectedColor.hex_to"
            class="d-flex mt-1 flex-1 text-small weight_500 clr-grey"
          >
            <div
              class="xaxis-clr-indicator"
              :style="`--color:${selectedColor.hex}`"
            >
              {{
                $t(
                  `settings.colors.${selectedColor.name === 'eveqeqrbl' ? 'worst' : 'smaller_bet'}`,
                )
              }}
            </div>
            <div
              v-if="selectedColor.name === 'eveqeqrbl'"
              class="ml-auto xaxis-clr-indicator"
              :style="`--color:${selectedColor.hex_middle}`"
            >
              {{ $t(`settings.colors.medium`) }}
            </div>
            <div
              class="ml-auto xaxis-clr-indicator is-last"
              :style="`--color:${selectedColor.hex_to}`"
            >
              {{
                $t(`settings.colors.${selectedColor.name === 'eveqeqrbl' ? 'best' : 'bigger_bet'}`)
              }}
            </div>
          </div>
          <div
            v-if="selectedColor.hex_to"
            class="mt-1 flex-1"
            :style="`
            min-height:1.25rem; border-radius:4px;
           background:linear-gradient(90deg, ${getGradient(selectedColor)})`"
          ></div>
          <div
            class="d-flex flex-wrap z-index_2 position-relative mt-2"
            style="gap: 0.5rem"
          >
            <!-- TODO vue3 add colorpicker -->
            <!-- TODO vue3 add colorpicker (gwcolorpicker)
            -- looking at this this needs serious refactor anyway as we have better components for this already
            -- ensure this color pisker has touch compatibily as vuetify2 did not had that
            -->
            <v-color-picker
              v-if="selectedColor"
              class="no-shadow no-background b-grey"
              :mode="hexMode"
              :dot-size="24"
              :modelValue="selectedColor.hex"
              @update:modelValue="clrHex => changeColor(clrHex, 'hex')"
            ></v-color-picker>
            <v-color-picker
              v-if="selectedColor.hex_middle"
              class="no-shadow no-background b-grey"
              :dot-size="24"
              :mode="hexMode"
              :modelValue="selectedColor.hex_middle"
              @update:modelValue="clrHex => changeColor(clrHex, 'hex_middle')"
            ></v-color-picker>
            <v-color-picker
              v-if="selectedColor.hex_to"
              class="no-shadow no-background b-grey"
              :dot-size="24"
              :mode="hexMode"
              :modelValue="selectedColor.hex_to"
              @update:modelValue="clrHex => changeColor(clrHex, 'hex_to')"
            ></v-color-picker>
          </div>
          <!-- @click="methods.toogleOpen(false)" -->
          <div
            class="d-flex mt-2"
            @click="methods.toggleOpen(false)"
          >
            <div
              class="gw_btn weight_500 mr-auto"
              @click="resetColor"
            >
              <i class="mdi text-semi-large mdi-replay mr-2"></i>
              {{ $t('btn.reset') }}
            </div>
            <div
              class="gw_btn gw_btn_primary weight_500"
              @click="saveColor"
            >
              {{ $t('btn.confirm') }}
            </div>
          </div>
        </div>
      </template>
    </GwMenu>
  </div>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import { apiClrDict } from '@/store/userSettings/apiDicts'
import { getColorPalleteKeys, colorPalettes } from '@/store/userSettings/colorPalettes'
import { setEveqeqrblColorList, colorLuminance } from '@/helpers/colors'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'SettingsColors',
  components: {
    GwMenu,
  },
  mixins: [float_mix],
  props: {
    colorList: Object,
    enabledColors: Array,
    hiddenColors: Array,
  },
  data() {
    return {
      colors: {},
      selectedColor: {},
    }
  },
  methods: {
    getGradient(item) {
      const res = item.hex_middle
        ? `${item.hex}, ${item.hex_middle}, ${item.hex_to}`
        : `${item.hex}, ${item.hex_to}`
      return res
    },
    setColorList() {
      const res = {}
      const dict = apiClrDict()

      let clrList = {}
      if (this.enabledColors) {
        this.enabledColors.forEach(c => {
          clrList[c] = this.colorList[c]
        })
      } else if (this.hiddenColors) {
        clrList = { ...this.colorList }
        this.hiddenColors.forEach(c => {
          delete clrList[c]
        })
      } else {
        clrList = { ...this.colorList }
      }

      Object.keys(clrList).forEach(key => {
        const dictItem = dict.find(i => i.feKey === key)
        const isClrSecond = dict.some(i => i.clrSecond === key)
        const isClrThird = dict.some(i => i.clrThird === key)
        if (dictItem?.clrSecond) {
          res[key] = {
            name: key,
            hex: clrList[key],
            hex_to: clrList[dictItem.clrSecond],
          }
          if (dictItem.clrThird) {
            res[key] = {
              name: key,
              hex: clrList[key],
              hex_middle: clrList[dictItem.clrSecond],
              hex_to: clrList[dictItem.clrThird],
            }
          }
        } else if (!isClrSecond && !isClrThird) {
          res[key] = { name: key, hex: clrList[key] }
        }
      })
      // debugger
      // console.log(res)
      this.colors = res
    },
    // https://stackoverflow.com/questions/9733288/how-to-programmatically-calculate-the-contrast-ratio-between-two-colors
    colorLuminance(hex, lum) {
      return colorLuminance(hex, lum)
    },
    changeColor(clrHex, key) {
      this.selectedColor = { ...this.selectedColor, [key]: clrHex }
    },
    selectColor(clr, e) {
      this.selectedColor = clr
    },
    resetColor() {
      const defaultPallete = colorPalettes().find(i => i.id === 'default')
      const defaultPalleteColors = defaultPallete.colors
      const selectedClrIdx = getColorPalleteKeys().indexOf(this.selectedColor.name)
      const clr = defaultPalleteColors[selectedClrIdx]

      this.selectedColor.hex = clr
      if (this.selectedColor.hex_to) {
        // R1_2
        const clr_to = defaultPallete.colors[selectedClrIdx + 1]
        this.selectedColor.hex_to = clr_to
      }
      if (this.selectedColor.hex_middle) {
        // eveqeqrbl
        const clr_middle = defaultPallete.colors[selectedClrIdx + 1]
        this.selectedColor.hex_middle = clr_middle
        const clr_to = defaultPallete.colors[selectedClrIdx + 2]
        this.selectedColor.hex_to = clr_to
      }
      if (this.selectedColor.name === 'R_default') {
        this.colors.R1.hex = defaultPalleteColors[8]
        this.colors.R1.hex_to = defaultPalleteColors[9]
        this.colors.R2.hex = defaultPalleteColors[10]
        this.colors.R2.hex_to = defaultPalleteColors[11]
        this.colors.R3.hex = defaultPalleteColors[12]
        this.colors.R3.hex_to = defaultPalleteColors[13]
        this.colors.R4.hex = defaultPalleteColors[14]
        this.colors.R4.hex_to = defaultPalleteColors[18]

        const clrs = ['R1', 'R2', 'R3', 'R4']
        clrs.forEach(key => {
          document.documentElement.style.setProperty(`--clr-${key}`, this.colors[key].hex)
          document.documentElement.style.setProperty(`--clr-${key}_2`, this.colors[key].hex_to)
        })
        // console.log(this.colors)
        // debugger
        this.finalizeColorSave()
        return
      }
      this.saveColor()
    },
    saveColor() {
      if (this.selectedColor.name === 'R_default') {
        const { hex } = this.selectedColor
        const resetByDefault = {
          R1: this.colorLuminance(hex, 0),
          R1_2: this.colorLuminance(hex, -0.08),
          R2: this.colorLuminance(hex, -0.16),
          R2_2: this.colorLuminance(hex, -0.24),
          R3: this.colorLuminance(hex, -0.32),
          R3_2: this.colorLuminance(hex, -0.4),
          R4: this.colorLuminance(hex, -0.48),
          R4_2: this.colorLuminance(hex, -0.56),
          // R5: this.colorLuminance(hex, -0.48),
        }
        const clrs = ['R1', 'R2', 'R3', 'R4']
        clrs.forEach(key => {
          this.colors[key].hex = resetByDefault[key]
          this.colors[key].hex_to = resetByDefault[`${key}_2`]
          document.documentElement.style.setProperty(`--clr-${key}`, this.colors[key].hex)
          document.documentElement.style.setProperty(`--clr-${key}_2`, this.colors[key].hex_to)
          document.documentElement.style.setProperty(`--clr-${key}-initial`, this.colors[key].hex)
          document.documentElement.style.setProperty(
            `--clr-${key}_2-initial`,
            this.colors[key].hex_to,
          )
        })
      }

      this.setColorVars(this.selectedColor)
      // this.resetSelectedColor()
      this.finalizeColorSave()
    },
    setColorVars(clrObj) {
      if (clrObj.name.includes('R')) {
        // document.documentElement.style.setProperty(`--clr-${clrObj.name}`, clrObj.hex)
        // this.colors[clrObj.name].hex = clrObj.hex
        // document.documentElement.style.setProperty(`--clr-${clrObj.name}_2`, clrObj.hex_to)
        // this.colors[clrObj.name].hex_to = clrObj.hex_to

        document.documentElement.style.setProperty(`--clr-${clrObj.name}`, clrObj.hex)
        document.documentElement.style.setProperty(`--clr-${clrObj.name}-initial`, clrObj.hex)
        this.colors[clrObj.name].hex = clrObj.hex
        document.documentElement.style.setProperty(`--clr-${clrObj.name}_2`, clrObj.hex_to)
        document.documentElement.style.setProperty(`--clr-${clrObj.name}_2-initital`, clrObj.hex_to)
        this.colors[clrObj.name].hex_to = clrObj.hex_to
      } else if (clrObj.name.includes('card_back')) {
        this.colors[clrObj.name].hex = clrObj.hex
        const { hex } = clrObj
        const hex2 = colorLuminance(hex, -0.2)
        const hex3 = colorLuminance(hex, -0.4)
        document.documentElement.style.setProperty('--clr-card_back', hex)
        document.documentElement.style.setProperty('--clr-card_back2', hex2)
        document.documentElement.style.setProperty('--clr-card_back3', hex3)
      } else {
        document.documentElement.style.setProperty(`--clr-${clrObj.name}`, clrObj.hex)
        this.colors[clrObj.name].hex = clrObj.hex
        if (clrObj.name.includes('eveqeqrbl')) {
          document.documentElement.style.setProperty(`--clr-${clrObj.name}`, clrObj.hex_middle)
          this.colors[clrObj.name].hex_middle = clrObj.hex_middle
          document.documentElement.style.setProperty(`--clr-${clrObj.name}`, clrObj.hex_to)
          this.colors[clrObj.name].hex_to = clrObj.hex_to

          setEveqeqrblColorList({
            clr1: clrObj.hex,
            clr2: clrObj.hex_middle,
            clr3: clrObj.hex_to,
          })
        }
      }
    },
    finalizeColorSave() {
      const patchData = {}
      Object.keys(this.colors).forEach(key => {
        const i = this.colors[key]
        patchData[key] = `${i.hex}${i.hex_middle || ''}${i.hex_to || ''}`
      })
      this.$store.dispatch('userSettings', patchData)
      this.$store.dispatch('resetColorSettings')

      this.$store.dispatch('gamestate_repaint_actions', 'ColorPalettes')
      this.$store.getters.hands_namespaces.forEach(nn => {
        this.$store.dispatch(`${nn}/gamestate_repaint_actions`, 'ColorPalettes')
      })
    },
  },
  computed: {
    hexMode() {
      return this.selectedColor.hex?.length > 8 ? 'hexa' : 'hex'
    },
  },
  watch: {
    colorList: {
      immediate: true,
      handler: 'setColorList',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.settings-colors {
  display: grid;
  grid-gap: 0.25rem;
  &_color {
    // align-items: center;
    padding: 0.25rem;
    justify-content: flex-start;
    flex-direction: column;
    // background: var(--clr-black-1);
    --clr-shadow: var(--clr-black-4);
    &:hover {
      border-radius: 4px;
      cursor: pointer;
      background: var(--clr-black-1-3);
      --clr-shadow: var(--clr-primary);
    }
    &_inner {
      display: flex;
      align-items: center;
    }
    .color {
      display: flex;
      align-items: center;
      &:hover {
        cursor: pointer;
      }
      &_inner {
        display: flex;
        align-items: center;
      }
      &_name {
        margin-left: 0.75rem;
        font-weight: 500;
      }
      &_gradient {
        width: 3rem !important;
        border-radius: 4px;
      }
      &_dot {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 1.5rem;
        width: 1.5rem;
        flex-shrink: 0;
        flex-grow: 0;
        box-shadow: 0px 0px 0px 1px var(--clr-shadow);
        position: relative;
        border-radius: 2px;
        overflow: hidden;
        --clr-dot: hotpink;
        --dot-size: calc(100% - 4px);
        // background: var(--clr-grey-3);
        &::before {
          content: '';
          width: var(--dot-size);
          height: var(--dot-size);
          background: var(--clr-dot);
          position: absolute;
          z-index: 1;
          border-radius: 2px;
        }
        &:after {
          content: '';
          height: var(--dot-size);
          width: var(--dot-size);
          background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGElEQVQYlWNgYGCQwoKxgqGgcJA5h3yFAAs8BRWVSwooAAAAAElFTkSuQmCC)
            repeat;
          position: absolute;
          border-radius: 2px;
        }
      }
    }
  }
}

.xaxis-clr-indicator {
  position: relative;
  display: flex;
  --color: black;
  margin-left: 4px;

  &:nth-child(2) {
    justify-content: center;
    margin-left: 0;
  }
  &.is-last {
    justify-content: flex-end !important;
    margin-right: 4px;
  }
  &:after {
    content: '';
    border-radius: 8px;
    position: absolute;
    top: 1.1rem;
    width: 1rem;
    height: 1.85rem;
    background-color: var(--color);
    z-index: 1;
    z-index: 1;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.6);
  }
}

.range-colors-switch {
  margin: 0;
  width: 10rem;
}
</style>
